import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { LandingPage } from "components/utils/LandingPage";
import Layout from "components/layout/Layout";
import ConfirmProvider from "components/hooks/useConfirm";
import PrivateRoute from "components/routes/PrivateRoute";
import { ApplicationSettingsProvider } from "components/hooks/useSettings";

import BulkPlanning from "view/planning/bulk/BulkPlanning";
import ContainerPlanning from "view/planning/container/ContainerPlanning";
import SkipperVoyageDetails from "view/voyages/SkipperVoyageDetails";

import ErrorBoundaryProvider from "./ErrorBoundaryProvider";
import * as Views from "./routeViews";

const routeConfig = [
	{ path: "/admin/*", element: <Views.Admin /> },
	{ path: "/agreementtypes/*", element: <Views.AgreementTypes /> },
	{ path: "/calls/*", element: <Views.Calls /> },
	{ path: "/cargos/*", element: <Views.Cargos /> },
	{ path: "/changelog/*", element: <Views.Changelog /> },
	{ path: "/charters/*", element: <Views.Charters /> },
	{ path: "/connectingvessels/*", element: <Views.ConnectingVessels /> },
	{ path: "/connectingvisits/*", element: <Views.ConnectingVisits /> },
	{ path: "/containertypes/*", element: <Views.ContainerTypes /> },
	{ path: "/containers/*", element: <Views.Containers /> },
	{ path: "/contracts/*", element: <Views.Contracts /> },
	{ path: "/controltower/*", element: <Views.ControlTower /> },
	{ path: "/corelogs/*", element: <Views.Corelogs /> },
	{ path: "/costtypes/*", element: <Views.CostTypes /> },
	{ path: "/customerupdate/*", element: <Views.CustomerUpdate /> },
	{ path: "/metabase/*", element: <Views.Metabase /> },
	{ path: "/defaulttablesettings/*", element: <Views.DefaultTableSettings /> },
	{ path: "/deliveryconditions/*", element: <Views.DeliveryConditions /> },
	{ path: "/documentation/*", element: <Views.Documentation /> },
	{ path: "/documents/*", element: <Views.Documents /> },
	{ path: "/fleets/*", element: <Views.Fleets /> },
	{ path: "/gasoilprices/*", element: <Views.GasoilPrices /> },
	{ path: "/geofencelogs/*", element: <Views.Geofences /> },
	{ path: "/inactivities/*", element: <Views.Inactivities /> },
	{ path: "/invoicegrouptypes/*", element: <Views.InvoiceGroupTypes /> },
	{ path: "/invoices/*", element: <Views.Invoices /> },
	{ path: "/invoicing/*", element: <Views.Invoicing /> },
	{ path: "/labels/*", element: <Views.Labels /> },
	{ path: "/locations/*", element: <Views.Locations /> },
	{ path: "/locationplanning/*", element: <Views.LocationPlanning /> },
	{ path: "/mappings/*", element: <Views.Mappings /> },
	{ path: "/maps/*", element: <Views.Maps /> },
	{ path: "/nominations/*", element: <Views.Nominations /> },
	{ path: "/notifications/*", element: <Views.Notifications /> },
	{ path: "/paymentterms/*", element: <Views.PaymentTerms /> },
	{ path: "/planning/ships/*", element: <Views.ShipPlanning /> },
	{ path: "/planning/terminals/*", element: <Views.TerminalPlanning /> },
	{ path: "/productcategories/*", element: <Views.ProductCategories /> },
	{ path: "/products/*", element: <Views.Products /> },
	{ path: "/purchasecharters/*", element: <Views.PurchaseCharters /> },
	{ path: "/pushingtug/*", element: <Views.PushingTug /> },
	{ path: "/quayavailabilities/*", element: <Views.Availabilities /> },
	{ path: "/recharge/*", element: <Views.Recharge /> },
	{ path: "/reefers/*", element: <Views.Reefer /> },
	{ path: "/relations/*", element: <Views.Relations /> },
	{ path: "/salescharters/*", element: <Views.SalesCharters /> },
	{ path: "/sailingreports/*", element: <Views.SailingReports /> },
	{ path: "/sailingschedules/*", element: <Views.SailingSchedules /> },
	{ path: "/ships/*", element: <Views.Ships /> },
	{ path: "/spotsalescharters/*", element: <Views.SpotSalesCharters /> },
	{ path: "/staffels/*", element: <Views.Staffels /> },
	{ path: "/statuses/*", element: <Views.Statuses /> },
	{ path: "/templates/*", element: <Views.Templates /> },
	{ path: "/terms/*", element: <Views.Terms /> },
	{ path: "/users/*", element: <Views.Users /> },
	{ path: "/vatcodes/*", element: <Views.VatCodes /> },
	{ path: "/voyages/*", element: <Views.Voyages /> },
	{ path: "/waterlevels/*", element: <Views.WaterLevels /> },

	{ path: "/bulkplanning/*", element: <BulkPlanning /> },
	{ path: "/containerplanning/*", element: <ContainerPlanning /> },
	{ path: "/declarations/*", element: <Views.Declarations /> },
	{ path: "/dashboard/*", element: <Views.Dashboard /> },
	{ path: "/skipper/voyage/:id?", element: <SkipperVoyageDetails /> },
];

const PrivateRoutes = () => {
	return (
		<ApplicationSettingsProvider>
			<ConfirmProvider>
				<Layout>
					<Suspense fallback={<div />}>
						<ErrorBoundaryProvider>
							<Routes>
								{routeConfig.map(({ path, element }) => (
									<Route
										key={path}
										path={path}
										element={<PrivateRoute>{element}</PrivateRoute>}
									/>
								))}

								<Route path="" element={<LandingPage />} />
								<Route path='*' element={<Views.PageNotFound />} />
							</Routes>
						</ErrorBoundaryProvider>
					</Suspense>
				</Layout>
			</ConfirmProvider>
		</ApplicationSettingsProvider>
	);
};

export default PrivateRoutes;
